import QrCode from './qr-code.svg';

export const Img = {
  QrCode,
};
